<script setup lang="ts">
import GbButton from '@/components/GbButton.vue'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { useCopyText } from '@/util/use_copy_text'

const props = defineProps({
  stringToCopy: {
    type: String,
    required: true
  },
  tooltipText: {
    type: String,
    required: false,
  },
  buttonText: {
    type: String,
    required: true,
    default: 'Copy'
  },
  buttonTheme: {
    type: String,
    required: false,
    default: 'bluePrimary'
  },
  customClass: {
    type: String,
    required: false
  },
  autoHideTooltip: {
    type: Boolean,
    default: false
  },
  autoHideDelay: {
    type: Number,
    default: 2000 // 2 seconds
  },
  size: {
    type: String,
    required: false,
    default: 'md'
  },
  iconClass: {
    type: String,
    required: false,
    default: 'material-icons-round'
  }
})
const emit = defineEmits(['copied'])

const { isTooltipOpen, copyText } = useCopyText()

const clickAction = async (event: MouseEvent) => {
  await copyText(props.stringToCopy, event, {
    autoHideTooltip: props.autoHideTooltip,
    autoHideDelay: props.autoHideDelay,
    onCopied: () => emit('copied')
  })
}
</script>
<template>
  <TooltipProvider :disabled="!isTooltipOpen">
    <Tooltip :open="isTooltipOpen" @update:open="(val) => !isTooltipOpen && (isTooltipOpen = val)">
      <TooltipTrigger as-child>
        <GbButton
          type="button"
          :gbTheme="props.buttonTheme"
          :size="props.size"
          :class="props.customClass"
          @click="clickAction"
        >
          <slot name="icon">
            <span :class="props.iconClass" class="mr-1 text-sm">file_copy</span>
          </slot> {{ props.buttonText }}
        </GbButton>
      </TooltipTrigger>
      <TooltipContent v-if="props.tooltipText && props.tooltipText.length > 0">
        <p>{{ props.tooltipText }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
